import React from 'react';
import {
  response,
  scoreSection
} from "./response.module.css"

const PreferenceFinal = (props) => (
  <>
	<div className={scoreSection}>
    <ul className={response}>
		{props.answerArray.map((x) => (
			<li>{x}</li>
		))}
	</ul>
</div>
  </>
)

export default PreferenceFinal